// If you modify this file, you might want to update also https://github.airbus.corp/gire/2i81-cicd-engine/blob/master/a/config/2i81-dfm-gire-api/prod/upload_matrix.json

// H160_B, BK117_D3, EC175_B, EC225_LP
export const HMI_FILES = [
  { name: 'CF',
    types: ['DMAU', 'WACS']
  },
  { name: 'AD',
    types: ['MFD', 'FMS']
  },
  { name: 'S/W',
    types: ['AMC', 'MFD', 'WACS', 'DMAU', 'PCF','FMS', 'ELSE']
  }
]
